let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6941t")).then(() => parcelRequire('hppmr'));